export class MissingTranslationError extends Error {}
export class MissingReplacementError extends Error {}
export class MissingCurrencyCodeError extends Error {}
export class MissingTimezoneError extends Error {}
export class InvalidI18nConnectionError extends Error {}
